import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress benign ResizeObserver loop warnings that some 3rd-party scripts
// emit (and which trigger React's dev error-overlay).
// Capture phase so we run BEFORE webpack-dev-server's overlay listener.
const RO_MSG = "ResizeObserver loop";
window.addEventListener(
  "error",
  (e) => {
    if (e?.message && e.message.includes(RO_MSG)) {
      e.stopImmediatePropagation();
      e.stopPropagation();
      e.preventDefault();
      return false;
    }
  },
  true
);
window.addEventListener(
  "unhandledrejection",
  (e) => {
    const msg = e?.reason?.message || String(e?.reason || "");
    if (msg.includes(RO_MSG)) {
      e.stopImmediatePropagation();
      e.stopPropagation();
      e.preventDefault();
      return false;
    }
  },
  true
);
// Also patch console.error to swallow the same noise so the CRA overlay
// (which listens to console.error) doesn't pop up.
const origConsoleError = console.error;
console.error = (...args) => {
  if (
    args.length > 0 &&
    typeof args[0] === "string" &&
    args[0].includes(RO_MSG)
  ) {
    return;
  }
  origConsoleError(...args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
